/*
 * File: IconElement.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 14, 2025 at 9:58 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 42px;
    height: 42px;
	display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.tertiaryBackground};
	color: ${({ theme }) => theme.primaryDecoration};
    border-radius: 5px;
    position: relative;
    flex-shrink: 0;

	svg {
		font-size: 1.2rem;
		color: ${({ theme }) => theme.primaryDecoration};
	}
`;
